import { Modify } from "--floponents-web/common/utils";
import * as React from "react";
import styled from "styled-components";

// Bare minimum implementation of radio buttons for date input

type RadioButtonProps = Modify<React.InputHTMLAttributes<HTMLInputElement>, {
    value: string
    checked?: boolean
    size?: "small"|"normal"
    type?: "radio"
    label?: string
    onChange?: (e: React.ChangeEvent<HTMLInputElement>, value: string) => void
}>

const RadioGroup = styled.div`
    margin: ${props => props.theme.spacing(0.5, 0, 0.5, 2)};
    &>label:not(:last-child) {
        margin-bottom: ${props => props.theme.spacing(0.5)};
    }
`;

const RadioGroupLabel = styled.div`
    margin-left: ${props => props.theme.spacing(1)};
`;

const RadioButton: React.FC<RadioButtonProps> = (props) => {
    const { value, label, checked, onChange, size, children } = props;
    return <StyledRadioButton checked={checked} size={size}>
        <input
            type="radio"
            value={value}
            checked={checked}
            onChange={(e) => onChange && onChange(e, e.target.value)} />
        <span/>
        {(label || children) && <div>{label || children}</div>}
    </StyledRadioButton>
}
type StyledRadioButtonProps = {
    checked?: boolean
    size?: "small"|"normal"
}
const StyledRadioButton = styled.label<StyledRadioButtonProps>`
    position: relative;
    display: flex;
    align-items: center;

    >input {
        pointer-events: auto;
        position: absolute;
        top: 0; left: 0; 
        width: 100%; height: 100%;
        margin: 0; padding: 0;
        appearance: none;
    }
    >span {
        position: relative;
        width: ${props => props.size == "small" ? 16 : 18}px;
        height: ${props => props.size == "small" ? 16 : 18}px;
        border-radius: 100%;
        background: ${props => props.checked ? props.theme.palette.primary.main : props.theme.palette.grey.darker};
        box-shadow: ${props => props.theme.shadows.inset};
        transition: background ${props => props.theme.transitions.toggle};
        cursor: pointer;

        :after {
            content: '';
            position:absolute;

            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            opacity: ${props => props.checked ? 1 : 0};
            height: ${props => props.size == "small" ? 6 : 8}px;
            width: ${props => props.size == "small" ? 6 : 8}px;
            background: ${props => props.theme.palette.primary.contrast};
            border-radius: 100%;
            box-shadow: 0 0 2px 2px rgba(0,0,0,0.1);
            transition: opacity ${props => props.theme.transitions.toggle};
        }

        :hover {
            background: ${props => props.checked ? props.theme.palette.primary.main : props.theme.palette.grey.main}
        }
    }
    >div {
        ${props => props.size == "small" ? props.theme.typography.body2 : props.theme.typography.body1}
        color: ${props => props.theme.palette.text.primary};
        margin: ${props => props.theme.spacing(0,0,0,1)};
        flex: 1 0 auto;
    }
`;

export default RadioButton;
export { RadioButton, RadioButtonProps, RadioGroup, RadioGroupLabel };